import { DevTools } from '@/components/common/DevTools'
import { NotFound } from '@/components/error/NotFound'
import { createRootRoute, Outlet } from '@tanstack/react-router'

const RootComponent = () => {
  return (
    <>
      <Outlet />
      <DevTools />
    </>
  )
}

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFound,
})
